import { gql } from "urql";

export const VERIFY_TOKEN_RESET_PASSWORD: any = gql(`
  query VerifyTokenResetPassword($token: String!) {
    VerifyTokenResetPassword(token: $token) 
  }
`)